import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <main className="bg-[#0A0A0A] min-h-screen pt-[120px] px-6 text-center">
        <p className="font-body text-sm" style={{ color: "rgba(255,255,255,0.5)" }}>Checking your session…</p>
      </main>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
